import React from 'react';
import PropTypes from 'prop-types';

const IconLockVioletO = ({ fill }) => (
  <g>
    <path
      d="M130.84 94.9032C144.871 61.0281 128.785 22.1919 94.9102 8.16012C61.0351 -5.87169 22.1989 10.2144 8.1671 44.0895C-5.86471 77.9646 10.2214 116.801 44.0965 130.833C77.9716 144.864 116.808 128.778 130.84 94.9032Z"
      stroke={fill}
      strokeWidth="7"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="stroke"
    />
    <path
      d="M94.5826 100.687H44.821C41.0206 100.687 37.8853 97.5754 37.8853 93.7512V51.3767C37.8853 47.5763 40.9968 44.4409 44.821 44.4409H94.5826C98.383 44.4409 101.518 47.5525 101.518 51.3767V93.7512C101.518 97.5517 98.383 100.687 94.5826 100.687Z"
      stroke={fill}
      strokeWidth="7"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="stroke"
    />
    <path
      d="M56.7209 42.4931C56.7209 35.3199 62.5403 29.5005 69.7136 29.5005C76.8869 29.5005 82.7062 35.3199 82.7062 42.4931"
      stroke={fill}
      strokeWidth="7"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="stroke"
    />
    <path
      d="M78.0509 68.9061C78.0509 64.2981 74.3218 60.5452 69.69 60.5452C65.082 60.5452 61.3291 64.2743 61.3291 68.9061C61.3291 71.8276 62.8255 74.3692 65.082 75.8656V86.1267H74.2743V75.8656C76.5545 74.3692 78.0509 71.8276 78.0509 68.9061Z"
      stroke={fill}
      strokeWidth="7"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="stroke"
    />
  </g>
);

IconLockVioletO.propTypes = {
  fill: PropTypes.string.isRequired,
};

export default IconLockVioletO;
